module.exports = __webpack_public_path__ + "img/comment.6f9de73d.png";